"use client";

import { Map, X } from "@/components/icons";
import {
  ProductTypeFilter,
  LocationFilter,
  QuantityFilter,
} from "./primary-filters";
import {
  ConditionFilter,
  PriceFilter,
  RecentlyListedFilter,
  StateFilter,
} from "./secondary-filters";
import { AdvancedFiltersToggle, AdvancedFiltersPanel } from "./advanced-filters";
import { IntentFilter } from "./intent-filter";
import { SearchInput } from "./search-input";
import { PhoneFilterBar } from "./phone-filter-bar";
import { useListingBrowseContext } from "../context/listing-browse-context";
import { ScrollableRow } from "@/components/ui/scrollable-row";
import { Button } from "@/components/ui/button";

function ClearFiltersButton() {
  const { hasActiveFilters, clearAllFilters } = useListingBrowseContext();
  if (!hasActiveFilters) return null;

  return (
    <>
      <div className="mx-1 h-5 w-px shrink-0 bg-border" />
      <Button
        type="button"
        variant="destructive-quiet"
        size="compact"
        onClick={clearAllFilters}
        className="rounded-sm hover:text-destructive-strong/80"
      >
        <X className="h-3.5 w-3.5" />
        Clear all
      </Button>
    </>
  );
}

function MapToggleButton() {
  const { mapVisible, toggleMap } = useListingBrowseContext();

  return (
    <Button
      type="button"
      variant="outline"
      size="compact"
      onClick={toggleMap}
      aria-pressed={mapVisible}
      className="hidden shrink-0 rounded-sm lg:inline-flex"
    >
      <Map />
      {mapVisible ? "Hide map" : "Show map"}
    </Button>
  );
}

export function HorizontalFilterBar({
  onOpenMap,
  resultCount,
}: {
  onOpenMap: () => void;
  resultCount: number | null;
}) {
  return (
    <div className="flex-shrink-0 border-b border-border bg-background">
      <PhoneFilterBar onOpenMap={onOpenMap} resultCount={resultCount} />
      <div className="hidden flex-col gap-2 px-4 py-3 md:flex lg:flex-row lg:items-center lg:gap-3">
        <SearchInput
          id="marketplace-filter-search"
          className="w-full lg:w-72 lg:shrink-0"
        />
        <ScrollableRow
          className="min-w-0 flex-1"
          showIndicatorsOnDesktop
          contentClassName="flex items-center gap-2"
        >
          <ProductTypeFilter />
          <LocationFilter />
          <IntentFilter />
          <PriceFilter />
          <ConditionFilter />
          <StateFilter />
          <RecentlyListedFilter />
          <QuantityFilter />
          <AdvancedFiltersToggle />
          <ClearFiltersButton />
        </ScrollableRow>
        <MapToggleButton />
      </div>

      <AdvancedFiltersPanel />
    </div>
  );
}
